export default __webpack_public_path__ + "079e54707ee07b45feb66e5d4db197fa.jpg";